import { KeyboardEvent } from "react"

const HORIZONTAL_SCROLL_STEP_PX = 60

// a11y: drive the wide table's horizontal scroll from an explicit handler. Safari won't reliably
// arrow-scroll a focused overflow container, and its scrollWidth under-reports the table so a
// scrollWidth-based max stops short of where the mouse reaches. Measure the max from the table's
// rendered right edge instead, and step both directions predictably. SC 2.1.1.
export const handleTableArrowScroll = (event: KeyboardEvent<HTMLElement>) => {
  if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return
  // Only scroll when the container itself holds focus, not a focusable descendant.
  if (event.target !== event.currentTarget) return

  const container = event.currentTarget
  const table = container.querySelector("table")
  if (!table) return

  const containerRight = container.getBoundingClientRect().right
  const tableRight = table.getBoundingClientRect().right
  const maxScrollLeft = Math.max(
    0,
    container.scrollLeft + Math.ceil(tableRight - containerRight)
  )
  if (maxScrollLeft <= 0) return

  event.preventDefault()
  const direction = event.key === "ArrowRight" ? 1 : -1
  const nextScrollLeft = container.scrollLeft + direction * HORIZONTAL_SCROLL_STEP_PX
  container.scrollTo({ left: Math.min(maxScrollLeft, Math.max(0, nextScrollLeft)) })
}
